import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

var firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDGxhBXC9hiRwLQ1Ae_dMrCLJzmgvabkHU",
  authDomain: "dibrugo-90c0d.firebaseapp.com",
  projectId: "dibrugo-90c0d",
  storageBucket: "dibrugo-90c0d.firebasestorage.app",
  messagingSenderId: "889399972886",
  appId: "1:889399972886:web:09bad49fc6e2be891f5137",
  measurementId: "G-MRXYVZK8N9",
});

// Initialize Firebase
var db = firebaseApp.firestore();
export const auth = getAuth(firebaseApp);
export const database = getDatabase(firebaseApp);
export const storage = getStorage(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
export { db };
